'use client'

import Link from 'next/link'
import { ContentWrapper } from '@/General/ContentWrapper'
import { ChevronDownIcon } from '@heroicons/react/24/solid'
import { useState } from 'react'

export const QAAccordion = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const items = [
    {
      question: 'How does the trial work?',
      answer:
        "Once your trial starts, you'll have immediate access to a Masterclass subscription for 30 days. Trial access is streaming only and will be revoked if you choose to cancel your trial early. Unless cancelled, your subscription will then renew at a prorated rate at the end of the trial period. You will then be charged the full rate for a subscription on the 1st of the month that immediately follows the end of your trial. Trials and subscriptions can be canceled with one click from your account.",
    },
    {
      question: 'When are the lectures held?',
      answer: 'The first three Sundays of the month, at 4pm ET/9pm GMT.',
    },
    {
      question: 'How long do I have to commit for?',
      answer:
        "There's no contract, and no minimum term; just a rolling monthly agreement. We're so confident you are going to love what you get, we've kept everything super simple.",
    },
    {
      question: 'When does my card get charged?',
      answer:
        'All subscriptions renew on the first of each month. If you are enjoying the trial and do not cancel within 30 days, you will be billed when your trial ends for the pro-rated amount until the end of the month, then next on the first of the following month.',
    },
    {
      question: "What if there is a lecturer that doesn't resonate with me?",
      answer: (
        <>
          Good question! You can pause your membership at any time. This means we
          will not bill you for the month you pause. Of course, you&apos;ll lose
          access to{' '}
          <Link
            href="/masterclass/studio/"
            className="text-vi-red hover:underline"
          >
            VI Studio
          </Link>{' '}
          and the streaming Masterclass catalog while you have paused your
          subscription, but as soon as you unpause, your access will be
          reinstated immediately.
        </>
      ),
    },
    {
      question: 'How do I view the lectures?',
      answer:
        "You can view everything right inside your VI account. We're using our own streaming technology, there's no software you need to install.",
    },
    {
      question: 'What if I want to cancel?',
      answer:
        "We really hope you won't want to. The value you receive with your subscription is now truly unrivaled in the world of magic. But, in the unlikely event that Vanishing Inc. Masterclass doesn't work out for you, you can cancel your subscription with one click from inside your member's area.",
    },
    {
      question:
        'If I subscribe now, do I get access to all the amazing lectures I missed?',
      answer: 'Yes! You will get streaming access to all past lectures.',
    },
    {
      question: 'Are there terms and conditions?',
      answer:
        'A few. But we believe in transparency and clear, human-language conditions. You can read them <a href="/faqs/masterclass-program-tandcs/" target="_blank" class="text-vi-red hover:underline">here</a>.',
    },
  ]

  const toggleIndex = (index: number) => {
    setOpenIndex((prev: number | null) => (prev === index ? null : index))
  }

  return (
    <section className="bg-[#f2f2f2] py-4 md:py-8">
      <ContentWrapper>
        <h2 className="text-xl md:text-3xl font-bold mb-4">
          Vanishing Inc. Masterclass Questions and Answers:
        </h2>
        <div className="space-y-2">
          {items.map((item, index) => (
            <div key={index} className="border-b">
              <button
                onClick={() => toggleIndex(index)}
                className="w-full text-left py-4 bg-[#f2f2f2] font-bold text-black focus:outline-none text-xl flex items-center justify-between cursor-pointer"
              >
                {item.question}
                <ChevronDownIcon
                  className={`w-6 h-6 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="pb-4 text-xl">
                  {typeof item.answer === 'string' &&
                  item.answer.includes('<a') ? (
                    <span dangerouslySetInnerHTML={{ __html: item.answer }} />
                  ) : (
                    item.answer
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </ContentWrapper>
    </section>
  )
}
